import { Link, useParams } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DeleteModal from "../../../components/deleteModal/DeleteModal";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from "../../../components/basics/Preloading";
import Paginations from "../../../components/paginaton/Paginations";

const OrderManagment = () => {
  const { branchId } = useParams();
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    cashDeskId: 0,
    saleUnitId: 0,
    categoryId: 0,
    orderType: 0,
    orderNumber: 0,
    posDeviceId: 0,
    size: 50,
    part: 1,
    invoiceNumber: "",
    merchantName: "",
    merchantPhone: "",
    merchantCode: "",
    paymentType: 0,
    orderStatus: -1,
    startDate: methods.toPersianDate(Date.now(), "jYYYY/jMM/jDD"),
    startTime: "",
    endDate: "",
    endTime: "",
    total: 0,
    parts: 0,
  });
  const [gridData, setGridData] = useState([]);
  const [orderTypes, setOrderTypes] = useState([]);
  const [resetKey, setResetKey] = useState(0);
  const [orderStatus, setOrderStatus] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [totalGridInfo, setTotalGridInfo] = useState({
    totalTaxFreePrice: 0,
    totalDiscount: 0,
    totalTax: 0,
    totalFinalPrice: 0,
    totalCount: 0,
  });
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState("");
  const [invoiceDetails, setInvoiceDetails] = useState({});
  const [saleUnits, setSaleUnits] = useState([]);
  const [localService, setLocalService] = useState({
    baseUrl: "",
  });
  const [printers, setPrinters] = useState([]);
  const [localPrinters, setlocalPrinters] = useState([]);
  const [invoicePirntInfo, setInvoicePirntInfo] = useState({
    footer1: "",
    footer2: "",
    footer3: "",
  });

  const [selectedPrinter, setSelectedPrinter] = useState({
    kitchenPrinterDevice: null,
    orderingPrinterDevice: null,
  });

  const [printModel, setPrintModel] = useState({
    kitchenPrintModel: null,
    orderPrintModel: null,
    printers: [],
  });

  const [order, setOrder] = useState({
    id: 0,
    invoiceNumber: "",
    orderNumber: 1,
    merchantName: " ",
    merchantCode: "",
    merchantPhone: "",
    destination: "",
    orderType: 0,
    paymentType: 0,
    orderStatus: 0,
    shipmentType: 0,
    isPaid: false,
    description: "",
    orderDescription: "",
    packingPrice: 0,
    servePrice: 0,
    cashDeskId: 0,
    saleUnitId: 0,
    merchantId: null,
    deliveryId: null,
    posDeviceId: null,
    diningTableId: null,
    pagerDeviceId: null,
    branchId: branchId,
    createDate: "",
    userId: "",
    shipmentId: null,
    CreatorType: 1,
  });

  const [orderItems, setOrderItems] = useState([]);
  const [totalNumbers, setTotalNumbers] = useState({
    totalFreeTaxPrice: 0,
    totalTax: 0,
    totalDiscount: 0,
    totalFinalPrice: 0,
    services: [],
  });

  const [packingConfig, setPackingConfig] = useState({
    useDefaultPackingPrice: false,
    servicePackingPrice: 0,
    finalPackingPrice: 0,
    totalMenusPackingPrice: 0,
  });

  let orderItem = {
    id: 0,
    saleMenuId: 0,
    amount: 1,
    description: "",
    packingPrice: 0,
    invoiceId: 0,
  };

  const resetOrderItem = () => {
    orderItem = {
      id: 0,
      saleMenuId: 0,
      amount: 1,
      description: "",
      invoiceId: 0,
    };
  };

  const resetOrder = () => {
    order.id = 0;
    order.invoiceNumber = "";
    order.orderNumber = 1;
    order.merchantName = "";
    order.merchantCode = "";
    order.merchantPhone = "";
    order.destination = "";
    //order.orderType = 1;
    order.paymentType = 0;
    order.orderStatus = 0;
    order.shipmentType = 0;
    order.isPaid = false;
    order.description = "";
    order.orderDescription = "";
    order.packingPrice = 0;
    order.servePrice = 0;
    //order.cashDeskId = "";
    //order.saleUnitId = "";
    order.merchantId = null;
    order.deliveryId = null;
    order.posDeviceId = null;
    order.diningTableId = null;
    order.pagerDeviceId = null;
    order.branchId = branchId;
    order.createDate = "";
    order.userId = "";
    order.shipmentId = null;
    order.CreatorType = 1;
    setOrder({ ...order });
    resetOrderItem();
    setOrderItems([]);
    // orderItems.splice(0, orderItems.length);
    // setOrderItems([...orderItems]);
    totalNumbers.totalFreeTaxPrice = 0;
    totalNumbers.totalTax = 0;
    totalNumbers.totalDiscount = 0;
    totalNumbers.totalFinalPrice = 0;
    totalNumbers.services = [];
    setTotalNumbers({ ...totalNumbers });
    //setPackingConfig({ ...packingConfig });
  };

  const getGridData = async () => {
    const resp = await apiMethod.getInvoices(
      branchId,
      filterModel.orderNumber,
      filterModel.saleUnitId,
      filterModel.cashDeskId,
      filterModel.posDeviceId,
      filterModel.invoiceNumber,
      filterModel.merchantName,
      filterModel.merchantPhone,
      filterModel.merchantCode,
      filterModel.orderType,
      filterModel.paymentType,
      filterModel.orderStatus,
      filterModel.startDate,
      filterModel.startTime,
      filterModel.endDate,
      filterModel.endTime,
      filterModel.part,
      filterModel.size
    );
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
      setTotalPages(resp.total);

      totalGridInfo.totalTaxFreePrice = resp.totalTaxFreePrice;
      totalGridInfo.totalDiscount = resp.totalDiscount;
      totalGridInfo.totalTax = resp.totalTax;
      totalGridInfo.totalFinalPrice = resp.totalFinalPrice;
      totalGridInfo.totalCount = resp.total;
      setTotalGridInfo({ ...totalGridInfo });
    }
  };

  const getBaseInfo = async () => {
    const orderStatusResp = await apiMethod.getOrderStatuses();
    const orderTypesResp = await apiMethod.getOrderTypes();
    const paymentResp = await apiMethod.getPaymentTypes();
    const unitResp = await apiMethod.getBranchSaleUnits(branchId);

    if (methods.showApiErrors(orderStatusResp))
      setOrderStatus(orderStatusResp.data);
    if (methods.showApiErrors(orderTypesResp))
      setOrderTypes(orderTypesResp.data);
    if (methods.showApiErrors(paymentResp)) setPaymentTypes(paymentResp.data);
    if (methods.showApiErrors(unitResp)) setSaleUnits(unitResp.data);

    await getPrinterSettings();
    getLocalPrinters();
  };

  const paymentTypeChanged = async (paymentType) => {
    order.paymentType = paymentType;
    setOrder({ ...order });
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getBaseInfo();
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, [branchId]);

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li
          key={i}
          className={
            filterModel.part === i ? "page-item active mx-1" : "page-item mx-1"
          }
        >
          <a
            className="page-link circular-pagination"
            onClick={() => {
              callPager(i);
            }}
          >
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.orderNumber = "";
    filterModel.cashDeskId = 0;
    filterModel.saleUnitId = 0;
    filterModel.categoryId = 0;
    filterModel.orderType = 0;
    filterModel.posDeviceId = 0;
    filterModel.orderNumber = 0;
    filterModel.size = 30;
    filterModel.part = 1;
    filterModel.invoiceNumber = "";
    filterModel.merchantName = "";
    filterModel.merchantPhone = "";
    filterModel.merchantCode = "";
    filterModel.paymentType = 0;
    filterModel.orderStatus = -1;
    filterModel.startDate = methods.toPersianDate(Date.now(), "jYYYY/jMM/jDD");
    filterModel.endDate = "";
    filterModel.total = 0;
    filterModel.parts = 0;
    setFilterModel({ ...filterModel });
    setResetKey((prev) => prev + 1);
  };

  const showInvoiceInfo = async (invoiceId) => {
    try {
      setLoading(true);
      const response = await apiMethod.getBulkOrderInfo(invoiceId);
      if (response.status === 200) {
        setInvoiceDetails(response.data);
        setShowInfoModal(true);
        setLoading(false);
      } else {
        methods.showErrors(response.messages);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const downloadExcelFile = async (invoiceId) => {
    setLoading(true);
    const resp = await apiMethod.getOfficialInvoiceExcelFile(invoiceId);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    setLoading(false);
    window.location = process.env.REACT_APP_ROOT_SALE_API + "/" + resp.data;
  };

  const syncOrderData = (model) => {
    order.id = model.id;
    order.invoiceNumber = model.invoiceNumber;
    order.orderNumber = model.orderNumber;
    order.merchantName = model.merchantName;
    order.merchantCode = model.merchantCode;
    order.merchantPhone = methods.formatPhoneNumber(model.merchantPhone);
    order.destination = model.destination;
    order.orderType = model.orderType;
    order.paymentType = model.paymentType;
    order.orderStatus = model.orderStatus;
    order.shipmentType = model.shipmentType;
    order.isPaid = model.isPaid;
    order.description = model.description;
    order.orderDescription = model.orderDescription;
    //order.packingPrice = model.packingPrice;
    order.cashDeskId = model.cashDeskId;
    order.saleUnitId = model.saleUnitId;
    order.merchantId = model.merchantId;
    order.deliveryId = model.deliveryId;
    order.posDeviceId = model.posDeviceId;
    order.diningTableId = model.diningTableId;
    order.pagerDeviceId = model.pagerDeviceId;
    order.shipmentId = model.shipmentId;
    order.branchId = branchId;
    order.createDate = model.createDate;
    setOrder(order);
  };

  const editItem = async (invoiceId) => {
    setLoading(true);
    const resp = await apiMethod.getBulkOrderInfo(invoiceId);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }

    syncOrderData(resp.data.invoice);
    setOrderItems(resp.data.invoiceItems);
    setTotalNumbers(resp.data.totalNumbers);

    setShowEditModal(true);
    setLoading(false);
  };

  const createNewItem = async () => {
    setLoading(true);
    const resp = await apiMethod.createInvoice(order);
    if (!methods.showApiErrors(resp)) return false;

    await getGridData();
    setShowEditModal(false);
    setLoading(false);
    return true;
  };

  const selectَItemToDelete = (item) => {
    setOrder(item);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeOrder(order.id);
      if (!methods.showApiErrors(resp)) return false;

      await getGridData();
      resetOrder();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const getStatusColor = (statusId) => {
    switch (statusId) {
      case 0:
        return "#5F5FFF";
      case 1:
        return "#FFE500";
      case 2:
        return "#FFA400";
      case 3:
        return "#94E5A1";
      case 4:
        return "#1C9602";
      case 5:
        return "#F12F45";
      case 6:
        return "#959393";
      default:
        return "#000000";
    }
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const closeModal = () => {
    resetOrder();
    setShowEditModal(false);
    setShowInfoModal(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const addMenuPackingPrice = (menuPackingPrice) => {
    if (!packingConfig.useDefaultPackingPrice) {
      packingConfig.totalMenusPackingPrice += menuPackingPrice;
      packingConfig.finalPackingPrice = packingConfig.totalMenusPackingPrice;
    }
    setPackingConfig({ ...packingConfig });
  };

  const removeMenuPackingPrice = (menuPackingPrice) => {
    if (!packingConfig.useDefaultPackingPrice) {
      if (packingConfig.totalMenusPackingPrice >= menuPackingPrice) {
        packingConfig.totalMenusPackingPrice -= menuPackingPrice;
        packingConfig.finalPackingPrice = packingConfig.totalMenusPackingPrice;
      } else packingConfig.finalPackingPrice = 0;
    }
    setPackingConfig({ ...packingConfig });
  };

  const removeItemFromOrder = async (itemId) => {
    const resp = await apiMethod.removeOrderItem(itemId);
    if (methods.showApiErrors(resp)) editItem(order.id);
  };

  const addOrderItem = async (itemId, menuId, amount, menuPackingPrice) => {
    // if (disabled && cardDisabled)
    //   return false;

    //console.log(`add: ${itemId} - ${menuId} - ${amount} - ${menuPackingPrice}`);

    addMenuPackingPrice(menuPackingPrice);

    // console.log(packingConfig);
    // return false;

    if (!(await createNewItem())) {
      return false;
    }

    resetOrderItem();

    if (itemId > 0) orderItem.id = itemId;
    if (menuId > 0) orderItem.saleMenuId = menuId;
    orderItem.invoiceId = order.id;
    orderItem.amount = amount;
    orderItem.packingPrice = packingConfig.finalPackingPrice;

    // if (!isValidOrderItem()) {
    //   setCardDisabled(false);
    //   return false;
    // }

    const orderItemResp = await apiMethod.addMenuToOrderItem(orderItem);
    if (!methods.showApiErrors(orderItemResp)) {
      //setCardDisabled(false);
      return false;
    }

    await editItem(order.id);
    //setCardDisabled(false);
  };

  const removeNumberOfItemFromOrder = async (
    itemId,
    menuId,
    amount,
    menuPackingPrice
  ) => {
    removeMenuPackingPrice(menuPackingPrice);
    resetOrderItem();

    if (itemId > 0) orderItem.id = itemId;
    if (menuId > 0) {
      orderItem.saleMenuId = menuId;
      orderItem.invoiceId = order.id;
      orderItem.amount = amount;
      orderItem.packingPrice = packingConfig.finalPackingPrice;
    }

    // if (!isValidOrderItem()) {
    //   return false;
    // }

    const apiResp = await apiMethod.removeMenuFromOrderItem(orderItem);
    if (!methods.showApiErrors(apiResp)) {
      return false;
    }

    await editItem(order.id);
  };

  const changeItemDescription = (e, itemId) => {
    const updatedOrderItems = orderItems.map((item) =>
      item.id === itemId ? { ...item, description: e.target.value } : item
    );
    setOrderItems(updatedOrderItems);
  };

  const saveItemDescription = async (item) => {
    const reqBody = {
      id: item.id,
      saleMenuId: item.saleMenuId,
      amount: item.amount,
      description: item.description,
      packingPrice: item.menuPackingPrice,
      invoiceId: item.invoiceId,
    };
    await apiMethod.createOrderItem(reqBody);
  };

  const validPrinters = (printerUnitType) => {
    if (printModel.printers.length === 0) {
      methods.showErrors([
        "خطا در تنظیمات پرینتر. هیچ دستگاهی در نرم افزار تعریف نشده است.",
      ]);
      return false;
    }

    if (printerUnitType === 1) {
      if (methods.isNullOrEmptyString(printModel.orderPrintModel.printerName)) {
        methods.showErrors([
          "خطا در تنظیمات پرینتر. هیچ دستگاهی برای آشپزخانه تعریف نشده است.",
        ]);
        return false;
      } else if (
        !localPrinters.includes(printModel.orderPrintModel.printerName)
      ) {
        methods.showErrors([
          "خطا در اتصالات دستگاه پرینتر " +
            printModel.orderPrintModel.printerName +
            " به کامپیوتر شما.",
        ]);
        return false;
      }
    }

    if (printerUnitType === 2) {
      if (
        methods.isNullOrEmptyString(printModel.kitchenPrintModel.printerName)
      ) {
        methods.showErrors([
          "خطا در تنظیمات پرینتر. هیچ دستگاهی برای صندوق تعریف نشده است.",
        ]);
        return false;
      } else if (
        !localPrinters.includes(printModel.kitchenPrintModel.printerName)
      ) {
        methods.showErrors([
          "خطا در اتصالات دستگاه پرینتر " +
            printModel.kitchenPrintModel.printerName +
            " به کامپیوتر شما.",
        ]);
        return false;
      }
    }

    return true;
  };

  const getPrinterSettings = async () => {
    const resp = await apiMethod.getSettingByName(branchId, "LocalServices");
    if (!methods.showApiErrors(resp)) return false;

    let settings = JSON.parse(resp.data.settingItems);
    let setting = await settings.find((x) => x.KeyName === "HostPath");
    localService.baseUrl = setting.SettingValue;
    setLocalService({ ...localService });
  };

  const getLocalPrinters = async () => {
    try {
      const localPrintersResp = await apiMethod.getLocalPrinters(
        localService.baseUrl
      );
      if (!methods.showApiErrors(localPrintersResp)) {
        throw new Error("Error fetching local printers");
      }
      setlocalPrinters(localPrintersResp.data);
    } catch (error) {
      methods.showErrors(["خطا در اتصال پرینتر "]);
      console.log(error);
    }
  };

  const setPrintModelData = async (invoiceId) => {
    const resp = await apiMethod.getOrderPrintInfo(invoiceId);
    if (methods.showApiErrors(resp)) {
      printModel.orderPrintModel = resp.data.orderPrintModel;
      printModel.kitchenPrintModel = resp.data.kitchenPrintModel;
      printModel.printers = resp.data.printers;
      setPrintModel({ ...printModel });
      await setPrinterDevices(printModel.printers);
      return true;
    } else {
      return false;
    }
  };

  const setPrinterDevices = async (printers) => {
    let orderPrinter = await printers.find((x) => x.printerUnitType === 1);
    let kitchenPrinter = await printers.find((x) => x.printerUnitType === 2);
    printModel.orderPrintModel.printerName = orderPrinter.name;
    printModel.kitchenPrintModel.printerName = kitchenPrinter.name;
    setPrintModel({ ...printModel });
  };

  const printOrderReceipt = async () => {
    if (!validPrinters(1)) return false;

    const apiRes = await apiMethod.orderBillPrint(
      localService.baseUrl,
      printModel.orderPrintModel
    );

    if (!methods.showApiErrors(apiRes)) return false;
  };

  const printKitchenOrder = async () => {
    if (!validPrinters(2)) return false;

    const apiRes = await apiMethod.kitchenOrderPrint(
      localService.baseUrl,
      printModel.kitchenPrintModel
    );

    if (!methods.showApiErrors(apiRes)) return false;
  };

  const printInvoice = async (invoiceId, printType) => {
    var isOkInfo = await setPrintModelData(invoiceId);
    if (!isOkInfo) return false;

    if (printType === 1 || printType === 3) await printOrderReceipt();

    if (printType === 2 || printType === 3) await printKitchenOrder();
  };

  const renderOrders = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block text-start mb-3">
              <Link to={`/sale/${branchId}/#1`} className="link back-link">
                <span>
                  <img src={back} alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link to={`/sale/${branchId}/#1`} className="link back-link">
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                مدیریت سفارش ها
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>
                مدیریت سفارش ها
                <a
                  href={`/sale/${branchId}/softwareGuide/#section12`}
                  className="link rtlicon me-1"
                  title="برای اطلاعات بیشتر کلیک کنید"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain">
              <div className="salesearchsection">
                <div className="row g-1">
                  <div className="col-md-4 col-lg-2">
                    <label htmlFor="ddlunits" className="form-label">
                      نام مشتری
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{
                        direction: "rtl",
                        textAlign: "right",
                        color: "black",
                      }}
                      value={filterModel.merchantName}
                      onChange={(e) =>
                        setFilterModel({
                          ...filterModel,
                          merchantName: e.target.value,
                          part: 1,
                        })
                      }
                    />
                  </div>
                  <div className="col-md-4 col-lg-2">
                    <label htmlFor="phone" className="form-label">
                      شماره تماس
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      id="phone"
                      aria-label="Add your item here..."
                      style={{
                        direction: "rtl",
                        textAlign: "right",
                        color: "black",
                      }}
                      value={filterModel.merchantPhone}
                      onChange={(e) =>
                        setFilterModel({
                          ...filterModel,
                          merchantPhone: e.target.value,
                          part: 1,
                        })
                      }
                    />
                  </div>
                  <div className="col-md-4 col-lg-2">
                    <label htmlFor="orderNum" className="form-label">
                      شماره سفارش
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      id="orderNum"
                      aria-label="Add your item here..."
                      style={{
                        direction: "rtl",
                        textAlign: "right",
                        color: "black",
                      }}
                      value={filterModel.orderNumber}
                      onChange={(e) =>
                        setFilterModel({
                          ...filterModel,
                          orderNumber: e.target.value,
                          part: 1,
                        })
                      }
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-2">
                    <label htmlFor="funit" className="form-label">
                      شماره فاکتور
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{
                        direction: "rtl",
                        textAlign: "right",
                        color: "black",
                      }}
                      value={filterModel.invoiceNumber}
                      onChange={(e) =>
                        setFilterModel({
                          ...filterModel,
                          invoiceNumber: e.target.value,
                          part: 1,
                        })
                      }
                    />
                  </div>
                  <div className="col-md-4 col-lg-2">
                    <label htmlFor="ddlunits" className="form-label">
                      بخش فروش
                    </label>
                    <select
                      id="ddlunits"
                      className="form-select form-select-md"
                      value={filterModel.saleUnitId}
                      onChange={(e) => {
                        filterModel.saleUnitId = parseInt(e.target.value);
                        setFilterModel({ ...filterModel });
                      }}
                    >
                      <option value={0}>همه‌ی بخش ها</option>
                      {saleUnits.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4 col-lg-2">
                    <label htmlFor="fstatus" className="form-label">
                      وضعیت
                    </label>
                    <select
                      id="fstatus"
                      className="form-select form-select-md"
                      value={filterModel.orderStatus}
                      // onChange={(e) => orderStatusChanged(e.target.value)}
                      onChange={(e) => {
                        filterModel.orderStatus = e.target.value;
                        setFilterModel({ ...filterModel });
                      }}
                    >
                      <option value={-1}>همه‌ی وضعیت‌ها</option>
                      {orderStatus.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-12 col-md-6 col-lg-2">
                    <label htmlFor="forder" className="form-label">
                      نوع سفارش
                    </label>
                    <select
                      id="forder"
                      className="form-select"
                      value={filterModel.orderType}
                      // onChange={(e) => orderTypeChanged(e.target.value)}
                      onChange={(e) => {
                        filterModel.orderType = e.target.value;
                        setOrder({ ...filterModel });
                      }}
                    >
                      <option value="0">همه</option>
                      {orderTypes.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-12 col-md-6 col-lg-2">
                    <label htmlFor="forder" className="form-label">
                      نوع پرداخت
                    </label>
                    <select
                      id="paymentType"
                      className="form-select"
                      aria-label="Default select example"
                      value={filterModel.paymentType}
                      onChange={(e) => {
                        filterModel.paymentType = e.target.value;
                        setFilterModel({ ...filterModel });
                      }}
                    >
                      {paymentTypes.map((paymentType) => (
                        <option key={paymentType.id} value={paymentType.id}>
                          {paymentType.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3 col-lg-2">
                    <label htmlFor="startDate" className="form-label">
                      از تاریخ
                    </label>
                    <DatePicker
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-center"
                      format="YYYY/MM/DD"
                      value={filterModel.startDate}
                      onChange={(value) => {
                        if (value)
                          filterModel.startDate = value.format("YYYY/MM/DD");
                        else filterModel.startDate = "";
                        setFilterModel({ ...filterModel });
                      }}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="startTime" className="form-label">
                      از ساعت
                    </label>
                    <DatePicker
                      key={`startTime-${resetKey}`}
                      disableDayPicker
                      format="HH:mm"
                      plugins={[
                        <TimePicker
                          hideSeconds
                          value={filterModel.startTime}
                        />,
                      ]}
                      onChange={(value) => {
                        if (value)
                          filterModel.startTime = value.format("HH:mm");
                        else filterModel.startTime = "";
                        setFilterModel({ ...filterModel });
                      }}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="enddate" className="form-label">
                      تا تاریخ
                    </label>
                    <DatePicker
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-center"
                      format="YYYY/MM/DD"
                      value={filterModel.endDate}
                      onChange={(value) => {
                        if (value)
                          filterModel.endDate = value.format("YYYY/MM/DD");
                        else filterModel.endDate = "";
                        setFilterModel({ ...filterModel });
                      }}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="endTime" className="form-label">
                      تا ساعت
                    </label>
                    <DatePicker
                      key={`endTime-${resetKey}`}
                      disableDayPicker
                      format="HH:mm"
                      plugins={[
                        <TimePicker hideSeconds value={filterModel.endTime} />,
                      ]}
                      onChange={(value) => {
                        if (value) filterModel.endTime = value.format("HH:mm");
                        else filterModel.endTime = "";
                        setFilterModel({ ...filterModel });
                      }}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </div>
                  <div
                    className="col-12 col-md-6 col-lg-2"
                    style={{ marginTop: "35px" }}
                  >
                    <button
                      type="button"
                      className="btn btn-purple me-1"
                      onClick={() => {
                        searchItem();
                      }}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-info"
                      onClick={clearSearch}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
                <div className="d-flex flex-column flex-lg-row mt-4">
                  <p>راهنمای رنگ ها: </p>
                  {orderStatus.map((status) => (
                    <p key={status.id} className="orderstatus mx-2">
                      <span
                        className="orderstatuscolor ms-1"
                        style={{ backgroundColor: getStatusColor(status.id) }}
                      ></span>
                      <span className="">{status.title}</span>
                    </p>
                  ))}
                </div>
              </div>
              <div className="row mt-4 mb-4">
                <div className="col-md-1">
                  تعداد: {totalGridInfo.totalCount}
                </div>
                <div className="col-md-3">
                  جمع فروش:{" "}
                  {methods.addNumSeperator(totalGridInfo.totalTaxFreePrice)}
                </div>
                <div className="col-md-3">
                  جمع تخفیف:{" "}
                  {methods.addNumSeperator(totalGridInfo.totalDiscount)}
                </div>
                <div className="col-md-2">
                  جمع مالیات: {methods.addNumSeperator(totalGridInfo.totalTax)}
                </div>
                <div className="col-md-3">
                  جمع قابل پرداخت:{" "}
                  {methods.addNumSeperator(totalGridInfo.totalFinalPrice)}
                </div>
              </div>
              <div className="table-responsive saletable">
                <table className="table table-striped table-md ">
                  <thead className="align-middle">
                    <tr>
                      <th width="20px">ردیف</th>
                      <th>بخش فروش</th>
                      <th>شماره فاکتور</th>
                      <th>شماره سفارش</th>
                      <th>صندوق</th>
                      <th>مشتری</th>
                      <th>وضعیت</th>
                      <th>نوع سفارش</th>
                      <th>نوع پرداخت</th>
                      <th>تاریخ ثبت</th>
                      <th>مبلغ کل</th>
                      <th width="150px">عملیات</th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <td scope="row">
                          {(filterModel.part - 1) * filterModel.size +
                            index +
                            1}
                        </td>
                        <td>{item.saleUnitTitle}</td>
                        <td>{item.invoiceNumber}</td>
                        <td>{item.orderNumber}</td>
                        <td>{item.cashDeskTitle}</td>
                        <td>
                          {item.merchantName}
                          <br />
                          {item.merchantCode ? (
                            <span>اشتراک {item.merchantCode}</span>
                          ) : (
                            ""
                          )}{" "}
                          <br />
                          {item.merchantPhone}
                        </td>
                        <td>
                          <div className="d-flex align-middle">
                            <span
                              className="orderstatuscolor ms-1"
                              style={{
                                backgroundColor: getStatusColor(
                                  item.orderStatus
                                ),
                              }}
                            ></span>
                            <span className="">
                              {
                                orderStatus.find(
                                  (status) => status.id === item.orderStatus
                                )?.title
                              }
                            </span>
                          </div>
                        </td>
                        <td>
                          {
                            orderTypes.find(
                              (orderType) => orderType.id === item.orderType
                            )?.title
                          }
                        </td>
                        <td>
                          {
                            paymentTypes.find(
                              (paymentType) =>
                                paymentType.id === item.paymentType
                            )?.title
                          }
                        </td>
                        <td>
                          {methods.toPersianDate(
                            item.createDate,
                            "jYYYY/jMM/jDD ساعت: HH:mm"
                          )}
                        </td>
                        <td>{methods.addNumSeperator(item.totalFinalPrice)}</td>
                        <td>
                          <div className="d-flex align-items-baseline">
                            <button
                              onClick={() => showInvoiceInfo(item.id)}
                              className="btn btn-sm btn-outline-purple"
                              type="button"
                            >
                              <i className="bi bi-file-text"></i>
                            </button>
                            <button
                              onClick={() => downloadExcelFile(item.id)}
                              className="btn btn-sm btn-outline-success mx-1"
                              type="button"
                            >
                              <i class="bi bi-file-earmark-excel"></i>
                            </button>
                            <button
                              onClick={() => editItem(item.id)}
                              className="btn btn-sm btn-outline-purple mx-1"
                              type="button"
                            >
                              <i className="bi bi-pencil-square"></i>
                            </button>
                            <button
                              onClick={() => selectَItemToDelete(item)}
                              className="btn btn-sm btn-outline-danger"
                              type="button"
                            >
                              <i className="bi bi-trash"></i>
                            </button>
                            <div className="dropdown-center d-inline-block">
                              <button
                                className="btn btn-sm btn-order m-2"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i className="bi bi-printer"></i>
                              </button>
                              <ul className="dropdown-menu p-0 mx-4">
                                <li
                                  className="dropdown-item btn btn-order btn-sm"
                                  onClick={async () => {
                                    printInvoice(item.id, 2);
                                  }}
                                >
                                  <i className="bi bi-printer ms-1"></i>
                                  چاپ آشپزخانه
                                </li>
                                <li
                                  className="dropdown-item btn btn-order btn-sm"
                                  onClick={async () => {
                                    printInvoice(item.id, 1);
                                  }}
                                >
                                  <i className="bi bi-printer ms-1"></i>
                                  چاپ صندوق
                                </li>
                              </ul>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 && (
                  <div className="pagination justify-content-center mt-5">
                    <Paginations
                      total={totalPages}
                      size={filterModel.size}
                      onPageChange={callPager}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  console.log({ "invoiceDetails:::": invoiceDetails });

  const ModalInfo = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showInfoModal ? "block" : "none" }}
      >
        <div className="modal-dialog  modal-xl" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">جزییات سفارش</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => closeModal()}
              ></button>
            </div>
            {invoiceDetails && (
              <>
                <div className="modal-body">
                  <div className="d-lg-flex justify-content-evenly my-2">
                    <p>شماره فاکتور: {invoiceDetails.invoice.invoiceNumber}</p>
                    <p>شماره سفارش: {invoiceDetails.invoice.orderNumber}</p>
                    <p>
                      نوع سفارش‌:{" "}
                      {
                        orderTypes.find(
                          (orderType) =>
                            orderType.id === invoiceDetails.invoice.orderType
                        )?.title
                      }
                    </p>
                    <p>
                      نوع پرداخت:{" "}
                      {
                        paymentTypes.find(
                          (paymentType) =>
                            paymentType.id ===
                            invoiceDetails.invoice.paymentType
                        )?.title
                      }
                    </p>
                    <p>
                      تاریخ ایجاد:{" "}
                      {methods.toPersianDate(
                        invoiceDetails.invoice.createDate,
                        "jYYYY/jMM/jDD"
                      )}
                    </p>
                    <p>
                      تاریخ پرداخت:{" "}
                      {methods.isNullOrEmptyString(
                        invoiceDetails.invoice.paymentDate
                      ) && <span>پرداخت نشده</span>}
                      {methods.toPersianDate(
                        invoiceDetails.invoice.paymentDate,
                        "jYYYY/jMM/jDD"
                      )}
                    </p>
                  </div>
                  <div>
                    <p className="bg-light p-2 text-center">مشخصات مشتری</p>
                    <div className="d-lg-flex">
                      <p className="col-lg-4 border border-1 border-light-subtle rounded p-2 d-flex justify-content-between">
                        مشتری:{" "}
                        <span>{invoiceDetails.invoice.merchantName}</span>
                      </p>
                      <p className="col-lg-4 border border-1 border-light-subtle rounded p-2 d-flex justify-content-between mx-1">
                        موبایل:
                        <span>{invoiceDetails.invoice.merchantPhone}</span>
                      </p>
                      <p className="col-lg-4 border border-1 border-light-subtle rounded p-2 d-flex justify-content-between">
                        کد اشتراک:
                        <span>{invoiceDetails.invoice.merchantCode}</span>
                      </p>
                    </div>
                    <div className="d-flex">
                      <p className="col-lg-6 border border-1 border-light-subtle rounded p-2">
                        آدرس:
                        <p className="text-break">
                          {invoiceDetails.invoice.destination}
                        </p>
                      </p>
                      <p className="col-lg-6 border border-1 border-light-subtle rounded p-2 ms-2">
                        توضیحات: {invoiceDetails.invoice.orderDescription}
                      </p>
                    </div>
                  </div>
                  <div className="table-responsive text-center">
                    <table className="table table-bordered">
                      <thead className="align-middle">
                        <tr>
                          <th className="bg-light" colSpan="9">
                            اطلاعات سفارش
                          </th>
                        </tr>
                        <tr>
                          <th width="20px">ردیف</th>
                          <th>نام کالا</th>
                          <th>کد کالا</th>
                          <th>قیمت واحد (ریال)</th>
                          <th>تعداد</th>
                          <th>توضیحات</th>
                          <th>تخفیف (ریال)</th>
                          <th>مالیات (ریال)</th>
                          <th>مجموع (ریال)</th>
                        </tr>
                      </thead>
                      <tbody className="align-middle">
                        {invoiceDetails.invoiceItems.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.productName}</td>
                            <td>{item.productCode}</td>
                            <td>
                              {methods.addNumSeperator(item.taxFreePrice)}
                            </td>
                            <td>{item.amount}</td>
                            <td>{item.description ? item.description : ""}</td>
                            <td>{methods.addNumSeperator(item.discount)}</td>
                            <td>{methods.addNumSeperator(item.tax)}</td>
                            <td>{methods.addNumSeperator(item.finalPrice)}</td>
                          </tr>
                        ))}
                        {invoiceDetails.totalNumbers.services.map(
                          (item, index) => (
                            <tr key={item.id}>
                              <td>
                                {invoiceDetails.invoiceItems.length + index + 1}
                              </td>
                              <td>{item.productName}</td>
                              <td>{item.productCode}</td>
                              <td>
                                {methods.addNumSeperator(item.taxFreePrice)}
                              </td>
                              <td>{item.amount}</td>
                              <td>
                                {item.description ? item.description : ""}
                              </td>
                              <td>{methods.addNumSeperator(item.discount)}</td>
                              <td>{methods.addNumSeperator(item.tax)}</td>
                              <td>
                                {methods.addNumSeperator(item.finalPrice)}
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                      <tfoot className="align-middle">
                        <tr className="fw-bold bg-light">
                          <td colSpan="4" className="text-end">
                            جمع کل:
                          </td>
                          <td>
                            {invoiceDetails.invoiceItems.reduce(
                              (total, item) => total + Number(item.amount || 0),
                              0
                            ) +
                              invoiceDetails.totalNumbers.services.reduce(
                                (total, item) =>
                                  total + Number(item.amount || 0),
                                0
                              )}
                          </td>
                          <td></td>
                          <td>
                            {methods.addNumSeperator(
                              invoiceDetails.totalNumbers.totalDiscount
                            )}
                          </td>
                          <td>
                            {methods.addNumSeperator(
                              invoiceDetails.totalNumbers.totalTax
                            )}
                          </td>
                          <td>
                            {methods.addNumSeperator(
                              invoiceDetails.totalNumbers.totalFinalPrice
                            )}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                    {/* <div className="d-flex align-items-center justify-content-between">
                      <span>
                        مجموع تعداد :{" "}
                        {invoiceDetails.invoiceItems.reduce(
                          (total, item) => total + Number(item.amount || 0),
                          0
                        )}
                      </span>
                      <span>
                        مجموع تخفیف:{" "}
                        {methods.addNumSeperator(
                          invoiceDetails.invoiceItems.reduce(
                            (total, item) => total + Number(item.discount || 0),
                            0
                          )
                        )}
                      </span>
                      <span>
                        مجموع مالیات:{" "}
                        {methods.addNumSeperator(
                          invoiceDetails.invoiceItems.reduce(
                            (total, item) => total + Number(item.tax || 0),
                            0
                          )
                        )}
                      </span>
                      <p className="p-2 text-end">
                        مجموع:{" "}
                        {methods.addNumSeperator(
                          invoiceDetails.totalNumbers.totalFinalPrice
                        )}{" "}
                        ریال
                      </p>
                    </div> */}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn custome-btn btn-link-purple"
                    onClick={() => setShowInfoModal(false)}
                  >
                    انصراف
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  const ModalEdit = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showEditModal ? "block" : "none" }}
      >
        <div className="modal-dialog  modal-xl" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">ویرایش فاکتور</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => closeModal()}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-3 mb-4">
                <div className="col-md-4">
                  <label htmlFor="invoiceNumber" className="form-label">
                    شماره فاکتور
                  </label>
                  <p>{order.invoiceNumber}</p>
                </div>
                {order.merchantName === "" ? (
                  <div className="col-md-4">
                    <label htmlFor="merchantName" className="form-label">
                      مشتری
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="merchantName"
                      name="merchantName"
                      value={order.merchantName}
                      onChange={(e) => {
                        setOrder({ ...order, merchantName: e.target.value });
                      }}
                    />
                  </div>
                ) : (
                  <div className="col-md-4">
                    <label htmlFor="merchantName" className="form-label">
                      مشتری
                    </label>
                    <p>{order.merchantName}</p>
                  </div>
                )}
                {order.merchantPhone === "" ? (
                  <div className="col-md-4">
                    <label htmlFor="merchantPhone" className="form-label">
                      تلفن
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="merchantPhone"
                      name="merchantPhone"
                      value={order.merchantPhone}
                      onChange={(e) => {
                        setOrder({ ...order, merchantPhone: e.target.value });
                      }}
                      readOnly
                    />
                  </div>
                ) : (
                  <div className="col-md-4">
                    <label htmlFor="merchantPhone" className="form-label">
                      تلفن
                    </label>
                    <p>{order.merchantPhone}</p>
                  </div>
                )}
                <div className="col-md-4">
                  <label htmlFor="status" className="form-label">
                    وضعیت
                  </label>
                  <select
                    id="status"
                    className="form-select"
                    aria-label="Default select example"
                    value={order.orderStatus}
                    onChange={(e) => {
                      setOrder({ ...order, orderStatus: e.target.value });
                    }}
                  >
                    <option value="">همه‌ی وضعیت‌ها</option>
                    {orderStatus.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4">
                  <label htmlFor="orderType" className="form-label">
                    نوع سفارش
                  </label>
                  <select
                    id="orderType"
                    className="form-select"
                    aria-label="Default select example"
                    value={order.orderType}
                    onChange={(e) => {
                      setOrder({ ...order, orderType: e.target.value });
                    }}
                  >
                    {orderTypes.map((orderType) => (
                      <option key={orderType.id} value={orderType.id}>
                        {orderType.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4">
                  <label htmlFor="paymentType" className="form-label">
                    نحوه پرداخت
                  </label>
                  <select
                    id="paymentType"
                    className="form-select"
                    aria-label="Default select example"
                    value={order.paymentType}
                    onChange={(e) => paymentTypeChanged(e.target.value)}
                  >
                    {paymentTypes.map((paymentType) => (
                      <option key={paymentType.id} value={paymentType.id}>
                        {paymentType.title}
                      </option>
                    ))}
                  </select>
                </div>
                {/* <div className="col-md-4 ">
                  <div className="form-check mt-2 mb-2">
                    <label className="form-check-label" htmlFor="chbenabled">
                      هزینه بسته‌بندی
                    </label>
                    <input
                      onChange={(e) => {
                        setOrder({
                          ...order,
                          useMenuPackingPrice: e.target.checked,
                        });
                      }}
                      checked={order.useMenuPackingPrice}
                      className="form-check-input"
                      type="checkbox"
                      id="chbenabled"
                    />
                  </div>
                </div> */}
                <div className="col-md-4"></div>
                <div className="col-md-4"></div>
                <div className="col-md-6">
                  <label htmlFor="destination" className="form-label">
                    آدرس
                  </label>
                  <textarea
                    type="text"
                    className="form-control"
                    id="destination"
                    name="destination"
                    rows={3}
                    value={order.destination || ""}
                    onChange={(e) => {
                      setOrder({ ...order, destination: e.target.value });
                    }}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="description" className="form-label">
                    توضیحات
                  </label>
                  <textarea
                    type="text"
                    className="form-control"
                    id="description"
                    name="description"
                    rows={3}
                    value={order.orderDescription || ""}
                    onChange={(e) => {
                      setOrder({ ...order, orderDescription: e.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="order-items">
                {/* <div className="border rounded p-1">
                  <table className="table table-md align-middle table-responsive text-center">
                    <thead className="align-middle">
                      <tr>
                        <th width="16px"></th>
                        <th width="20px">
                          #
                        </th>
                        <th >عنوان کالا</th>
                        <th >تعداد</th>
                        <th >قیمت(تومان)</th>
                        <th >توضیحات</th>
                      </tr>
                    </thead>
                    <tbody className="align-middle">
                      {orderItems.map((item, index) => (
                        <tr key={item.id}>
                          <td className="p-0">
                            <span
                              onClick={() => {
                                removeItemFromOrder(item.id);
                              }}
                              className="text-danger cursor-pointer"
                            >
                              <i className="bi bi-x-square"></i>
                            </span>
                          </td>
                          <td className="p-0">{index + 1}</td>
                          <td>{item.productName}</td>
                          <td>
                            <div className="orderPriceCell">
                              <i
                                className="bi bi-plus-circle"
                                onClick={() => {
                                  addOrderItem(
                                    item.id,
                                    item.saleMenuId,
                                    1,
                                    item.menuPackingPrice
                                  );
                                }}
                              ></i>
                              <span className="mx-1 my-1">{item.amount}</span>
                              <i
                                className="bi bi-dash-circle"
                                onClick={() => {
                                  removeNumberOfItemFromOrder(
                                    item.id,
                                    item.saleMenuId,
                                    1,
                                    item.menuPackingPrice
                                  );
                                }}
                              ></i>
                            </div>
                          </td>
                          <td>
                            {methods.addNumSeperator(
                              (item.taxFreePrice * item.amount) / 10
                            )}
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={item.description}
                              onChange={(e) =>
                                changeItemDescription(e, item.id)
                              }
                              onBlur={() => saveItemDescription(item)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div> */}
                <div className="text-start mt-3 p-1">
                  <p>
                    جمع فروش:
                    {methods.addNumSeperator(
                      totalNumbers.totalFreeTaxPrice
                    )}{" "}
                    ریال
                  </p>
                  <p>
                    جمع تخفیف:
                    {methods.addNumSeperator(totalNumbers.totalDiscount)} ریال
                  </p>
                  {totalNumbers.services.map((item) => (
                    <p key={item.id}>
                      {item.productName}:{" "}
                      {methods.addNumSeperator(item.taxFreePrice)} ریال
                    </p>
                  ))}
                  <p>
                    مالیات وعوارض :
                    {methods.addNumSeperator(totalNumbers.totalTax)} ریال
                  </p>
                  <p>
                    مبلغ قابل پرداخت:
                    {methods.addNumSeperator(totalNumbers.totalFinalPrice)} ریال
                  </p>
                  {/* <p>توضیحات سفارش:</p>
                  <textarea
                    value={order.orderDescription}
                    onChange={(e) => {
                      setOrder({ ...order, orderDescription: e.target.value });
                    }}
                    type="text"
                    className="form-control mb-4"
                    id="orderDescription"
                    name="orderDescription"
                  /> */}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple  "
                onClick={() => closeModal()}
              >
                انصراف
              </button>
              <button
                type="submit"
                className="btn custome-btn btn-purple"
                onClick={() => {
                  createNewItem();
                }}
              >
                ثبت وذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderOrders()}
      {showInfoModal && ModalInfo()}
      {showEditModal && ModalEdit()}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDeleteModal}
          deleteItem={deleteItem}
          text={"سفارش"}
        />
      )}
    </>
  );
};

export default OrderManagment;
